// Helper component for individual detail items
const DetailItem = ({ label, value }: { label: string; value: string }) => (
  <div className="border-b pb-2">
    <dt className="text-sm font-medium text-gray-500 capitalize">{label}:</dt>
    <dd className="text-sm text-gray-900 mt-1">{value || "Not provided"}</dd>
  </div>
);

export default DetailItem;